import { render, staticRenderFns } from "./SecurityQuestion.vue?vue&type=template&id=75e97957"
import script from "./SecurityQuestion.vue?vue&type=script&lang=js"
export * from "./SecurityQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports